import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/varmepumpar/")({
  head: () => seoHead("/varmepumpar", { description: "Uppvärmningen står för den största delen av elräkningen i en villa. Få kostnadsfria offerter på luft/vatten, bergvärme eller frånluftsvärmepump." }),
  component: () => <OffertKategori slug="varmepumpar" />,
});
